import { Control, FieldErrors } from 'react-hook-form';

import { ContentCard } from 'apps/dashboard/shared/scripts/components';

import { FormValues } from '../types';

import SenderNameField from './SenderNameField';
import { cardDeliveryClassName } from './styles';

interface Props {
  control: Control<FormValues>;
  errors?: FieldErrors<FormValues>;
}

const CardDelivery = (props: Props) => {
  return (
    <ContentCard>
      <div className={cardDeliveryClassName}>
        <SenderNameField {...props} />
      </div>
    </ContentCard>
  );
};

CardDelivery.displayName = 'CardDelivery';

export default CardDelivery;
